import React from 'react';
import { FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PropTypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import {
  LoginWithPasskeyButton,
  NavigateToLoginButton,
} from 'Views/Authentication/Components';
import {
  AuthenticationLayout,
  AuthenticationLayoutForm,
  AuthenticationSubmitButton,
} from '../../Components';
import { usePasswordResetEmail } from './usePasswordResetEmail';

export const AuthPasswordResetLayout = ({ setAuthCollection }) => {
  const { resource, onSubmit, unsourcedErrors } = useMetaLayoutContext();
  const loaded = usePasswordResetEmail(resource, setAuthCollection);

  if (!loaded) {
    return null;
  }

  return (
    <AuthenticationLayout>
      <AuthenticationLayoutForm
        id={'password-reset-email-form'}
        onSubmit={onSubmit}
        errors={unsourcedErrors}
      >
        <FDStack direction={'column'} spacing={2}>
          <NavigateToLoginButton resource={resource} />
          <MetaControlField attr={'address'} CustomProps={{ fullWidth: true }} {...dataAttrs('input-email')} />
          <MetaControlField attr={'password'} CustomProps={{ fullWidth: true }} {...dataAttrs('input-password')} />
          <AuthenticationSubmitButton />
          <LoginWithPasskeyButton setAuthCollection={setAuthCollection} />
        </FDStack>
      </AuthenticationLayoutForm>
    </AuthenticationLayout>
  );
};

AuthPasswordResetLayout.propTypes = {
  setAuthCollection: PropTypes.func.isRequired,
};
